<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import type ERAR from '$lib/erar/spec';
  import type { ComponentProps } from 'svelte';
  import { equipmentSubcategories } from './consts';
  import ItemImage from './item-image.svelte';
  import {
    getEquipmentSubcategoryWithGeneralizedWeapon,
    getSubcategoryWithGeneralizedWeapon,
    idToItem,
  } from './stores';
  import { getSubcategoryName } from './translation';
  import type { PlayerEquipment } from './types';
  import type RawItemImage from './raw-item-image.svelte';

  export let itemIds: ERAR.Schema.MatchParticipation['preferences']['equipments'];
  export let size: ComponentProps<RawItemImage>['size'] = 5;

  const equipments: PlayerEquipment = {};
  $: {
    for (const id of itemIds) {
      const item = $idToItem.get(id);
      if (!item) continue;

      const key = getEquipmentSubcategoryWithGeneralizedWeapon(item.itemSubcategoryId ?? '');
      equipments[key] = item;
    }
  }
</script>

<div class="equipment">
  {#each Object.values(equipmentSubcategories) as itemSubcategory, i}
    {#if Object.hasOwn(equipments, itemSubcategory)}
      {@const id = equipments[itemSubcategory]?.id ?? -1}
      <slot name="item-image" {id}>
        <ItemImage {id} {size} />
      </slot>
    {:else}
      <div class="placeholder" data-size={size}>
        <img
          alt={getSubcategoryName($LL, itemSubcategory)}
          src="/images/common/Ico_Status_{itemSubcategory}.webp"
          height={(size ?? 5) * (30 / 5) - 8}
        />
      </div>
    {/if}
  {/each}
</div>

<style lang="postcss">
  .equipment {
    display: flex;
    gap: var(--space-2);
  }

  .placeholder {
    border-radius: var(--radius-1);
    border: 1px solid var(--border-normal);
    background-color: var(--elevation-2);
    display: flex;
    place-items: center;
    place-content: center;

    &[data-size='8'] {
      width: 8rem;
      height: 5rem;
      border-radius: var(--radius-2);
    }

    &[data-size='5'] {
      width: 5rem;
      height: 3rem;
    }

    &[data-size='4'] {
      width: 4rem;
      height: 2.5rem;
    }

    &[data-size='3'] {
      width: 3rem;
      height: 1.8rem;
    }
  }
</style>
